import type { TRIOnsiteRecyclingProcessDataType } from '../../types/form-r.ts';
import type { CasOrCategory } from '../../types/db.ts';
import type { QuestionnaireAnswers } from '../../types/questionnaires.ts';
import type { Warning } from '../../types/tri.ts';

export function formRSection7cRecycling({
  chemicalName,
  casOrCategory,
  onSiteRecycling,
  warnings,
}: {
  chemicalName: string;
  casOrCategory: CasOrCategory;
  onSiteRecycling: QuestionnaireAnswers['onSiteRecycling'][CasOrCategory];
  warnings: Warning[];
}): TRIOnsiteRecyclingProcessDataType {
  if (!onSiteRecycling || onSiteRecycling.isApplicable === null) {
    warnings.push({
      warningID: 'TW1020',
      type: 'questionnaire',
      subType: 'onSiteRecycling',
      casOrCategory,
      message: `${chemicalName} (${casOrCategory}), we could not find answers for on site recycling.`,
      blocksPriorYearSection8Calculation: false,
    });
    onSiteRecycling = { isApplicable: false, methods: [] };
  } else if (onSiteRecycling.isApplicable && onSiteRecycling.methods.length === 0) {
    warnings.push({
      warningID: 'TW1021',
      type: 'questionnaire',
      subType: 'onSiteRecycling',
      casOrCategory,
      message: `${chemicalName} (${casOrCategory}), it was specified that on-site recycling is performed, but no methods were provided.`,
      blocksPriorYearSection8Calculation: false,
    });
  }

  if (onSiteRecycling.isApplicable) {
    return {
      choice: 'OnsiteRecyclingMethodCode',
      value: onSiteRecycling.methods,
    };
  } else {
    return {
      choice: 'NA',
      value: true,
    };
  }
}
